import { getMsgDeskRuntime, type LegacyRuntimeGlobals, type MsgDeskRuntime } from '@/msgdeskRuntime/runtime/MsgDeskRuntime'
import type { MsgDeskParams } from '@/msgdeskRuntime/types'

export interface BootMsgDeskRuntimeOptions {
  surface?: string
  params?: MsgDeskParams
  bootLegacy?: boolean
  readParamsFromHost?: boolean
  installAlertHook?: boolean
}

export interface BootMsgDeskRuntimeResult {
  runtime: MsgDeskRuntime
  legacyRuntime: LegacyRuntimeGlobals | null
}

export async function bootMsgDeskRuntime(options: BootMsgDeskRuntimeOptions = {}): Promise<BootMsgDeskRuntimeResult> {
  const runtime = getMsgDeskRuntime(options.surface || 'template2')
  const shouldBootLegacy = options.bootLegacy ?? true
  const legacyRuntime = shouldBootLegacy ? await runtime.boot() : runtime.legacyRuntime

  if (options.params) {
    runtime.setParams(options.params)
  } else if (options.readParamsFromHost ?? true) {
    runtime.ensureParamsFromUrl()
  }

  if (options.installAlertHook ?? true) runtime.installAlertHook()

  return { runtime, legacyRuntime }
}
